export default "__VITE_ASSET__CB_0XSYc__"